import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectDetailMobileListItemComponent } from "@components/project-cards/project-detail-mobile-list-item/project-detail-mobile-list-item.component";

@Component({
  selector: "app-project-detail-mobile-file-card",
  templateUrl: "./project-detail-mobile-file-card.component.html",
  styleUrls: ["./project-detail-mobile-file-card.component.scss"],
  standalone: true,
  imports: [UiKitModule, ProjectDetailMobileListItemComponent],
})
export class ProjectDetailMobileFileCardComponent {
  @Input({ required: true }) fileName!: string;
  @Input() fileType?: string;
  @Input() expanded = false;
  @Input() isReadOnlyUser = false;
  @Input() hasWritePermission = false;

  @Output() delete$ = new EventEmitter<void>();
  @Output() download$ = new EventEmitter<void>();
  @Output() toggleExpand$ = new EventEmitter<void>();

  protected readonly iconList = [
    { type: "application/pdf", icon: "file-pdf" },
    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", icon: "file-excel" },
    { type: "text/csv", icon: "file-csv" },
    { type: "application/vnd.ms-powerpoint", icon: "file-ppt" },
    { type: "video/x-ms-wmv", icon: "file-wmv" },
    { type: "application/msword", icon: "file-word" },
    { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", icon: "file-word" },
    { type: "application/x-zip-compressed", icon: "file-zip" },
    { type: "application/zip", icon: "file-zip" },
    { type: "application/zip-compressed", icon: "file-zip" },
    { type: "image/png", icon: "file-png" },
    { type: "image/jpeg", icon: "file-jpg" },
    { type: "image/svg+xml", icon: "file-svg" },
  ];

  onToggleExpand() {
    this.toggleExpand$.emit();
  }

  onDownload() {
    this.download$.emit();
  }

  onDelete() {
    if (this.hasWritePermission) {
      this.delete$.emit();
    }
  }

  protected setIcon() {
    return this.iconList.find((item) => item.type === this.fileType)?.icon ?? "file-others";
  }
}
